import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  createGalleryImage, getGallery, getGalleryImageId, updateGalleryImage, updateGalleryImagesOrder, updateGalleryImageStatus,
} from '../../axios/galleryRequests';
import {
  convertCountriesToISOCodeString,
} from '../../constants/countries';
import {
  uploadSingleImage, uploadSingleVideo,
} from '../../helperFunctions/uploadService';
import {
  ICountry,
} from '../storeInterfaces/authInterface';
import {
  IGalleryStore,
} from '../storeInterfaces/galleryInterface';
import { RequestStatus } from 'mobx-store';

export class GalleryStore implements IGalleryStore {
  @observable galleryList: any[] = [];

  @observable selectedImage = {
  };

  @observable loading = false;

  @observable getGalleryRequestStatus: RequestStatus = RequestStatus.IDLE;

  @action
  public async getGallery(countries: ICountry[]): Promise<any> {
    try {
      this.loading = true;
      this.getGalleryRequestStatus = RequestStatus.LOADING;
      const availableCountries = convertCountriesToISOCodeString(countries);

      const params = {
        availableCountries,
        status: 'all',
      };

      const response = await Connections.wadiDeglaAxios.httpGet(getGallery, {
        params,
      });
      this.galleryList = this.restructureGalleryList(response.data);
      this.getGalleryRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getGalleryRequestStatus = RequestStatus.FAILED;
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async getImageById(id: number): Promise<any> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getGalleryImageId(id));
      this.selectedImage = this.restructureImage(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async createImage(newImage: any): Promise<any> {
    try {
      const imageUrl = await uploadSingleImage(newImage.image);
      const videoUrl = await uploadSingleVideo(newImage.video);
      newImage.image = imageUrl;
      newImage.video = videoUrl;
      const response = await Connections.wadiDeglaAxios.httpPost(createGalleryImage, this.restructureCreateImage(newImage));
    } catch (error) {
      console.log(error);
    }
  }

  @action.bound
  public async updateImage(updatedImage: any, id: number): Promise<any> {
    try {
      console.log(updatedImage.image);
      const imageUrl = await uploadSingleImage(updatedImage.image);
      const videoUrl = await uploadSingleVideo(updatedImage.video);
      updatedImage.image = imageUrl;
      updatedImage.video = videoUrl;
      console.log(updatedImage);
      const response = await Connections.wadiDeglaAxios.httpPut(updateGalleryImage(id), this.restructureUpdatedImage(updatedImage));
    } catch (error) {
      console.log(error);
    }
  }

  @action.bound
  public async updateImageStatus(updatedImageStatus: boolean, index: number): Promise<any> {
    try {
      const response = await Connections.wadiDeglaAxios.httpPut(updateGalleryImageStatus(this.galleryList[index].imageId), {
        isActive: updatedImageStatus,
      });
      this.galleryList[index].isActive = updatedImageStatus;
    } catch (error) {
      console.log(error);
    }
  }

  @action.bound
  public async swapTwoImageOrder(imageOneIndex: number, imageTwoIndex: number): Promise<any> {
    try {
      const response = await Connections.wadiDeglaAxios.httpPut(updateGalleryImagesOrder, {
        imageOneId: this.galleryList[imageOneIndex].imageId,
        imageTwoId: this.galleryList[imageTwoIndex].imageId,
      });
      const tempImage = {
        ...this.galleryList[imageOneIndex],
      };
      this.galleryList[imageOneIndex] = {
        ...this.galleryList[imageTwoIndex],
      };
      this.galleryList[imageTwoIndex] = tempImage;
    } catch (error) {
      console.log(error);
    }
  }

  private restructureGalleryList(gallery: any[]): any[] {
    const galleryList = [];
    for (const image of gallery) {
      galleryList.push({
        imageId: image.imageId,
        image: image.imageURL,
        video: image.videoURL,
        isActive: image.isActive,
      });
    }
    return galleryList;
  }

  private restructureImage(media: any): any {
    const restructuredImage = {
      imageId: media.imageId,
      image: (media.imageURL ? [{
        imageUrl: media.imageURL, key: 1, type: 'image',
      }] : []),
      video: (media.videoURL ? [{
        videoUrl: media.videoURL, key: 2, type: 'video',
      }] : []),
    };
    return restructuredImage;
  }

  private restructureUpdatedImage(image: any): any {
    const restructuredImage = {
      imageURL: image.image,
      videoURL: image.video,
      availableCountries: image.availableCountries,
    };
    return restructuredImage;
  }

  private restructureCreateImage(image: any): any {
    const restructuredImage = {
      imageURL: image.image,
      videoURL: image.video,
      isActive: true,
      availableCountries: image.availableCountries,
    };
    return restructuredImage;
  }
}
